<h2 class="mb-4">Registration forms ready for your review</h2>
<table id="dt-for-approval" datatable class="table row-bordered table-hover" [dtOptions]="dataTableOptions">
</table>